import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { DomSanitizer } from '@angular/platform-browser';
import { LoggingService } from '../../../../../services/logging.service';

const apiServer = environment.apiServer;
declare var $: any;

@Component({
  selector: 'app-modal-mail-sender',
  templateUrl: './modal-mail-sender.component.html',
  styleUrls: ['./modal-mail-sender.component.sass']
})
export class ModalMailSenderComponent implements OnInit {
  http: HttpClient;
  spinner: NgxSpinnerService;
  sanitizer: DomSanitizer;
  private isVisible: boolean = false;
  mail = {participant:undefined, idAuction:undefined, mailTo:undefined, mailCopy:undefined, mailTopic:undefined,  mailBody:undefined};

  returnValue: any

  constructor(private _http: HttpClient, private _spinner: NgxSpinnerService, private _sanitizer: DomSanitizer, private loggingService: LoggingService) {
    this.http = _http;
    this.spinner = _spinner;
    this.sanitizer = _sanitizer
   }

  ngOnInit() {
    $('#modalMailSender').on('show.bs.modal', function () {
      $('#modalAuctionDetail').css({'z-index': 1030});
    })

    $('#modalMailSender').on('hidden.bs.modal', function () {
      $('#modalAuctionDetail').css({'z-index': 1041});
    })
  }

  onSave(){
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.ModalMailSenderComponent.onSave', null, 'Save started');
      
      if($("#myform").find('.form-control:invalid').length !== 0){
        console.log("invalid!");
        this.loggingService.logFinish(_xid, 'App.Components.ModalMailSenderComponent.onSave', null, 'Save cancelled - invalid form');
      }
      else{
        this.sendEmail();
        this.loggingService.logFinish(_xid, 'App.Components.ModalMailSenderComponent.onSave', null, 'Save completed');
      }
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.ModalMailSenderComponent.onSave', _error, null, 'Save failed');
      throw _error;
    }
  }

  public sendEmail() {
    const _xid = this.loggingService.generateUUID();
    this.loggingService.logStart(_xid, 'App.Components.ModalMailSenderComponent.sendEmail', null, 'Send email started');
    
    this.http.post<string>(apiServer + "/email/SendEmail", this.mail).subscribe(resp => {
      this.returnValue.value = this.sanitizer.bypassSecurityTrustHtml(resp)
      setTimeout(() => {
        this.returnValue.value = ""
      }, 5000)
      this.loggingService.logFinish(_xid, 'App.Components.ModalMailSenderComponent.sendEmail', null, 'Send email completed');
    }, error => {
      this.loggingService.logError(_xid, 'App.Components.ModalMailSenderComponent.sendEmail', error, null, 'Send email failed');
    });
  }
  
  public mailToCommercialOffer(code, distributerParticipant, returnedValue){
    const _xid = this.loggingService.generateUUID();
    this.loggingService.logStart(_xid, 'App.Components.ModalMailSenderComponent.mailToCommercialOffer', null, 'Mail to commercial offer started');
    
    this.spinner.show();

    this.http.get<Array<string>>(apiServer + "/commercial_offer/"+ code + "/" + distributerParticipant + "/" + 0)
    .subscribe(resp => { 
      this.spinner.hide();
      this.mail.participant = distributerParticipant;
      this.mail.idAuction = code;
      this.mail.mailTo = resp["mailTo"];
      if(resp["mailFrom"] != null){
        this.mail.mailCopy = resp["mailFrom"];
      }else{
        this.mail.mailCopy = " ";
      }
      this.mail.mailTopic = resp["mailTopic"];
      this.mail.mailBody = resp["mailBody"];
      this.loggingService.logFinish(_xid, 'App.Components.ModalMailSenderComponent.mailToCommercialOffer', null, 'Mail to commercial offer completed');
    }, error => {
      this.spinner.hide();
      this.loggingService.logError(_xid, 'App.Components.ModalMailSenderComponent.mailToCommercialOffer', error, null, 'Mail to commercial offer failed');
    });

    this.returnValue = returnedValue
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-modal-detail/modal-mail-sender/modal-mail-sender.component.ts